import { useState, useEffect, useCallback } from "react";
import { triggerHaptic } from "../utils/haptics";

// Zadania otwarte rozpoznajemy po braku dystraktorów (tylko poprawna odpowiedź).
export const isOpenProblem = (problem) =>
    !!problem && !problem.false_answer1 && !problem.false_answer2 && !problem.false_answer3;

/**
 * Drabinka samooceny dla zadań otwartych (rozszerzenie).
 *
 * SPRAWDŹ ODPOWIEDŹ → poprawna odpowiedź → MAM DOBRZE / MAM INACZEJ,
 * a po "MAM INACZEJ" pełne rozwiązanie → DROBNY BŁĄD / POWAŻNE BŁĘDY.
 * Wspólne dla sesji nauki i niepewniaków.
 */
export const useOpenProblemFlow = ({ currentProblem, handleAnswerClick, handleSolution }) => {
    const [openRevealed, setOpenRevealed] = useState(false); // po "Sprawdź odpowiedź"
    const [openLadder, setOpenLadder] = useState(false);     // po "Mam inaczej" (pełne rozwiązanie)
    const [openPick, setOpenPick] = useState(null);          // 'good1'|'bad1'|'good2'|'bad2'

    useEffect(() => {
        setOpenRevealed(false);
        setOpenLadder(false);
        setOpenPick(null);
    }, [currentProblem?.problem_id]);

    const pickGood = useCallback((tag) => {
        setOpenPick(tag);
        handleAnswerClick({ text: currentProblem?.true_answer, isCorrect: true });
    }, [currentProblem, handleAnswerClick]);

    const pickBad1 = useCallback(() => {
        setOpenPick('bad1');
        triggerHaptic('error');
        setOpenLadder(true);
    }, []);

    const pickBad2 = useCallback(() => {
        setOpenPick('bad2');
        handleSolution();
    }, [handleSolution]);

    return {
        isOpen: isOpenProblem(currentProblem),
        openRevealed,
        setOpenRevealed,
        openLadder,
        openPick,
        pickGood,
        pickBad1,
        pickBad2,
    };
};
